import { cn } from '../../utils/cn';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-lg bg-primary/30', className)} {...props} />;
}

export { Skeleton };
